module.exports = __webpack_public_path__ + "static/media/nieman.e3d249b6.svg";